<template>
  <div class="d-flex justify-content-center">
    <div class="bg-white d-flex flex-column" layout>
      <SummaryComp
        v-for="key in Object.keys(summaries)"
        :key="key"
        :summary="summaries[key]"
        :title="toCamelCase(key)"
      />
      <!-- {{ summaries }} -->
    </div>
  </div>
</template>

<script>
import SummaryComp from "@/components/dashboard/SummaryComp.vue";
import utils from "@/libraries/utils/utils";

import { mapGetters } from "vuex";

export default {
  name: "DashboardView",
  data() {
    return {};
  },
  components: {
    SummaryComp,
  },
  mounted() {
    this.$store.dispatch("dashboard/getSummaries");
  },
  methods: {
    toCamelCase(string) {
      return utils.toCamelCase(string);
    },
  },
  computed: {
    ...mapGetters("dashboard", ["summaries"]),
  },
};
</script>

<style scoped></style>
